<!-- 弹窗页面-消耗的备品备件列表 -->
<template>
  <a-card :bordered="false" class="devicebpbjList">
    <div style="color: rgba(0, 0, 0, 0.85);font-weight: bold;margin-bottom: 20px;" v-if="canEdit">备件消耗</div>
    <!-- 操作按钮区域 -->
    <div class="table-operator" v-if="canEdit">
      <a-button @click="addBj" size="small" type="primary" v-if="!showTitle">新增</a-button>
      <!-- 高级查询区域 -->
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item @click="batchDel" key="1">
            <a-icon type="delete" />删除
          </a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px">
          批量操作
          <a-icon type="down" />
        </a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <!-- <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择 <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div>-->

      <a-table
        :columns="columns"
        :customRow="customRowRender"
        :dataSource="dataSource"
        :loading="loading"
        :pagination="false"
        :rowSelection="{
            selectedRowKeys: selectedRowKeys,
            onChange: onSelectChange,
            onSelectAll: onSelectAll
          }"
        :scroll="{
          x: `${columns.length}0%`,
          y:270
        }"
        @change="handleTableChange"
        bordered
        class="j-table-force-nowrap"
        ref="table"
        rowKey="id"
        size="middle"
        v-if="canEdit"
      >
        <template slot="count" slot-scope="text, record">
          <editable-cell :text="text" @change="onCellChange(record, 'count', $event)" />
        </template>
        <!-- <template slot="count" slot-scope="text, record">
          <a-input-number 
            :min="0" 
            :max="10000"  
            :default-value="0"
            @change="onChange($event,record)"
            >
          </a-input-number>
        </template>-->

        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">编辑</a>

          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">
              更多
              <a-icon type="down" />
            </a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a @click="handleDetail(record)">详情</a>
              </a-menu-item>
              <a-menu-item>
                <a-popconfirm @confirm="() => handleDelete(record.id)" title="确定删除吗?">
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>
      </a-table>
      <a-table
        :columns="columns"
        :customRow="customRowRender"
        :dataSource="dataSource"
        :loading="loading"
        :pagination="false"
        :rowSelection="null"
        :scroll="{
          x: `${columns.length}0%`,
          y:270
        }"
        @change="handleTableChange"
        bordered
        class="j-table-force-nowrap"
        ref="table"
        rowKey="id"
        size="middle"
        v-else
      >
        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">编辑</a>

          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">
              更多
              <a-icon type="down" />
            </a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a @click="handleDetail(record)">详情</a>
              </a-menu-item>
              <a-menu-item>
                <a-popconfirm @confirm="() => handleDelete(record.id)" title="确定删除吗?">
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>
      </a-table>
    </div>

    <!-- <dev-bpbj-leadout-record-modal ref="modalForm" @ok="modalFormOk"/> -->
  </a-card>
</template>

<script>
  import { httpAction, getAction, deleteAction, putAction } from '@/api/manage'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  // import DevBpbjLeadoutRecordModal from './modules/DevBpbjLeadoutRecordModal'
  import EditableCell from "@/components/EditableCell"
  import '@/assets/less/TableExpand.less'
  export default {
    name: "DevicebpbjList",
    mixins: [JeecgListMixin],
    components: {
      EditableCell,
      // DevBpbjLeadoutRecordModal
    },
    props: {
      planId: {
        type: String,
        default: ''
      },
      canEdit: {
        type: Boolean,
        default: false,
      },
      showTitle: {
        type: Boolean,
        default: true,
      },
    },
    data () {
      return {
        queryParam: {

        },
        description: 'dev_bpbj_leadout_record管理页面',
        // 表头
        columns: [
          {
            title: '设备名称',
            align: "center",
            dataIndex: 'devName',
            width: 160,
          },
          {
            title: '备件名称',
            align: "center",
            dataIndex: 'bjName',
            width: 160,
          },
          {
            title: '备件型号',
            align: "center",
            dataIndex: 'bjModel',
            width: 200,
          },
          {
            title: '使用数量',
            align: "center",
            dataIndex: 'count',
            width: 80,
            scopedSlots: { customRender: 'count' }
          },
          {
            title: '单位',
            align: "center",
            dataIndex: 'unit',
            width: 50,
          },
          // {
          //   title:'设备类型',
          //   align:"center",
          //   dataIndex: 'devClassId',
          //   width: 100,
          // },
          // {
          //   title:'设备型号',
          //   align:"center",
          //   dataIndex: 'devModelId',
          //   width: 100,
          // },
        ],
        url: {
          list: "/spareparts/devBpbjLeadoutList/queryDevBpbjLeadoutListByRepairPlanId",
          delete: "/spareparts/devBpbjLeadoutList/delete",
          deleteBatch: "/spareparts/devBpbjLeadoutList/deleteBatch",
          // exportXlsUrl: "/org.jeecg.modules.spareparts/devBpbjLeadoutRecord/exportXls",
          // importExcelUrl: "org.jeecg.modules.spareparts/devBpbjLeadoutRecord/importExcel", 
        },
        dictOptions: {},
        superFieldList: [],
        dataSource: [],
        disableMixinCreated: true
        // selectedRowKeys:[],

      }
    },
    watch: {
      planId (newv) {
        if (newv) {
          this.getData(newv)
        }
      }
    },
    created () {
      this.getSuperFieldList();
    },
    methods: {
      initDictConfig () {
      },
      getSuperFieldList () {
        let fieldList = [];
        fieldList.push({ type: 'string', value: 'adoptionCode', text: '领用单编码', dictCode: '' })
        fieldList.push({ type: 'date', value: 'adoptionTime', text: '领用时间' })
        fieldList.push({ type: 'BigDecimal', value: 'totalAmount', text: '领用总金额', dictCode: '' })
        fieldList.push({ type: 'string', value: 'adopterId', text: '领用人', dictCode: '' })
        fieldList.push({ type: 'string', value: 'adopterName', text: '领用人名称', dictCode: '' })
        fieldList.push({ type: 'date', value: 'registerTime', text: '登记时间' })
        fieldList.push({ type: 'string', value: 'remark', text: '备注', dictCode: '' })
        fieldList.push({ type: 'string', value: 'taskTable', text: '任务来源表', dictCode: '' })
        fieldList.push({ type: 'string', value: 'repairPlanId', text: '检修计划ID', dictCode: '' })
        fieldList.push({ type: 'string', value: 'ywUnit', text: '运维单位', dictCode: '' })
        fieldList.push({ type: 'int', value: 'delFlag', text: '删除状态', dictCode: '' })
        this.superFieldList = fieldList
      },
      getData (planId) {

        const params = {
          repairPlanId: this.planId || planId
        }
        getAction(this.url.list, params)
          .then(res => {
            if (res.success) {
              this.dataSource = res?.result
            } else {
              this.$message.error(res.message)
            }
          })
      },
      clear () {
        this.dataSource = []
      },
      // 删除选中的备品备件数据
      handleDelete (ids) {
        return deleteAction(this.url.delete, { id: ids.join(',') })
          .then(res => {
            if (res.success) {
              this.dataSource = this.dataSource.filter(item => !ids.includes(item.id))
              return res
            } else {
              return Promise.reject()
            }
          })
      },
      onSelectAll () {

      },
      batchDel () {
        if (this.selectedRowKeys.length <= 0) {
          this.$message.warning('请选择一条记录！')
        } else {
          var ids = [];
          for (var a = 0; a < this.selectedRowKeys.length; a++) {
            ids.push(this.selectedRowKeys[a]);
          }
          this.dataSource = this.dataSource.filter(item => !ids.includes(item.id))
        }
      },
      onCellChange (item, key, value) {
        console.log('item--', item)
        console.log('key--', key)
        console.log('value--', value)
        item[key] = value
        // 调用保存接口
        // putAction('/spareparts/devBpbjLeadoutList/edit', item)
        //   .then(res => {
        //     this.$message.success(res.message)
        //   })
      },
      addBj () {
        this.$emit('addBj')
      }

    }
  }
</script>
<style scoped>

  @import '~@assets/less/common.less';

</style>
<style lang="less">
  .devicebpbjList {
    .ant-card-body {
      padding: 12px 24px;
    }
  }
</style>
